import { render, staticRenderFns } from "./FeaturedCategoriesWidget.vue?vue&type=template&id=10688b63&scoped=true"
import script from "./FeaturedCategoriesWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedCategoriesWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FeaturedCategoriesWidget.vue?vue&type=style&index=0&id=10688b63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10688b63",
  null
  
)

export default component.exports